import { render, staticRenderFns } from "./profits.vue?vue&type=template&id=7673e5e8&scoped=true&"
import script from "./profits.vue?vue&type=script&lang=js&"
export * from "./profits.vue?vue&type=script&lang=js&"
import style0 from "./profits.vue?vue&type=style&index=0&id=7673e5e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7673e5e8",
  null
  
)

export default component.exports